export interface Endpoint {
  method?: string;
  path: string;
}

export interface Endpoints {
  [x: string]: Endpoint;
}

const ENDPOINTS: Endpoints = {
  CAD: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/files/CAD',
  },
  BAG: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/publications/BAG',
  },
  PMG: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/publications/PMG',
  },
  IVM: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/publications/IVM',
  },
  BBLB: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/publications/BBLB',
  },
  SVEB: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/publications/SVEB',
  },
  PMB: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/publications/PMB',
  },
  RVTTG: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/publications/RVTTG',
  },
  NEWSLETTER: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/v2/files/newsletter',
  },
  BEMM: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/v2/files/bemm',
  },
  SVO: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/v2/files/svo',
  },
  VS: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/publications/VS',
  },
  WN: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/publications/WN',
  },
  ALLFILES: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/publications',
  },
  ALLFILES_EU: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/v2/files/all',
  },
  TOP_DOWNLOADS: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/publications/top-downloads',
  },
  AEM_CAD: {
    method: 'GET',
    path: '/content/dam/fordpro/{{country-code}}/{{language}}/{{category}}/cad/endpoint.pro-model.json',
  },
  AEM_PUBLICATIONS: {
    method: 'GET',
    path: '/content/dam/fordpro/{{country-code}}/{{language}}/{{category}}/publications/endpoint.pro-model.json',
  },
  AEM_CONTACTUS: {
    method: 'GET',
    path: `/content/dam/fordpro/{{country-code}}/{{language}}/{{category}}/contact-us/endpoint.pro-model.json`,
  },
  AEM_CONTACTUS2: {
    method: 'GET',
    path: `/content/dam/fordpro/{{country-code}}/{{language}}/{{category}}/contact-us2/endpoint.pro-model.json`,
  },
  AEM_CAD2: {
    method: 'GET',
    path: '/content/dam/fordpro/{{country-code}}/{{language}}/{{category}}/cad2/endpoint.pro-model.json',
  },
  AEM_UPFITTER: {
    method: 'GET',
    path: `/content/dam/fordpro/{{country-code}}/{{language}}/upfit/pro-upfitter/endpoint.pro-model.json`,
  },
  AEM_THANKYOU: {
    method: 'GET',
    path: `/content/dam/fordpro/{{country-code}}/{{language}}/{{category}}/thank-you/endpoint.pro-model.json`,
  },
  AEM_UNSUBSCRIBE: {
    method: 'GET',
    path: `/content/dam/fordpro/{{country-code}}/{{language}}/{{category}}/publications/unsubscribe/endpoint.pro-model.json`,
  },
  CAD_REQUEST: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/v2/files/cad',
  },
  AEM_LANDINGPAGE: {
    method: 'GET',
    path: '/content/dam/fordpro/{{country-code}}/{{language}}/upfit/bbas/endpoint.pro-model.json',
  },
  AEM_EU_LANDING_PAGE: {
    method: 'GET',
    path: '/content/dam/fordpro/{{country-code}}/{{language}}/special-vehicles/overview/endpoint.pro-model.json',
  },
  FILE_DOWNLOAD: {
    path: `${window?.ENV_CONFIG?.REACT_APP_API_HOST}/pro/bbas/download`,
  },
  EMAIL_SUBSCRIPTION: {
    method: 'POST',
    path: '/pro/bbas/api/notify/subscribe',
  },
  EMAIL_UNSUBSCRIBE: {
    method: 'POST',
    path: '/pro/bbas/api/notify/unsubscribe',
  },
  SWG_REQUEST: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/v2/files/swg',
  },
  DIGI_BEMM_FILE_URL: {
    method: 'GET',
    path: '/pro/bbas/api/retrieval/v2/files/bemm/',
  },
  AEM_EU_WEB_BEMM_PAGE: {
    method: 'GET',
    path: '/content/dam/fordpro/{{country-code}}/{{language}}/special-vehicles/publications/digibemm/endpoint.pro-model.json',
  },
};

export default ENDPOINTS;
